import { Skeleton } from 'antd';
import styled from 'styled-components';
export const Container = styled(Skeleton.Node).withConfig({
  displayName: "RecipeCoverstyle__Container",
  componentId: "sc-32uhxh-0"
})(["", " svg{", "}@media (max-width:", "){", "}@media (max-width:", "){", "}"], {
  "position": "relative",
  "height": "700px !important",
  "width": "100% !important"
}, {
  "display": "none"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "height": "520px !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "height": "auto !important"
});
export const Wrapper = styled.div.withConfig({
  displayName: "RecipeCoverstyle__Wrapper",
  componentId: "sc-32uhxh-1"
})(["", ""], {
  "position": "absolute",
  "inset": "0px",
  "marginLeft": "auto",
  "marginRight": "auto",
  "maxWidth": "1140px"
});
export const VideoSkeleton = styled(Skeleton.Image).withConfig({
  displayName: "RecipeCoverstyle__VideoSkeleton",
  componentId: "sc-32uhxh-2"
})(["", " svg{", "}@media (max-width:", "){", "}"], {
  "position": "absolute",
  "bottom": "0px",
  "marginLeft": "auto",
  "marginRight": "auto",
  "aspectRatio": "16 / 9",
  "height": "auto !important",
  "width": "100% !important",
  "borderRadius": "0px !important"
}, {
  "display": "none"
}, ({
  theme
}) => theme.breakpoint.md, {
  "position": "relative",
  "inset": "0px"
});
export const ContentContainer = styled.div.withConfig({
  displayName: "RecipeCoverstyle__ContentContainer",
  componentId: "sc-32uhxh-3"
})(["", " .content-skeleton .ant-skeleton-title{", "}.content-skeleton .ant-skeleton-paragraph li{", "}@media (max-width:", "){", " .content-skeleton .ant-skeleton-title{", "}.content-skeleton .ant-skeleton-paragraph li{", "}}"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "marginTop": "3rem",
  "marginBottom": "3rem",
  "width": "100%",
  "maxWidth": "750px"
}, {
  "height": "3rem !important",
  "width": "20rem !important"
}, {
  "height": "1.5rem !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "1.5rem",
  "marginBottom": "1.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem"
}, {
  "marginTop": "1rem",
  "height": "2.5rem !important",
  "width": "18rem !important"
}, {
  "height": "1.25rem !important"
});